import { GENERATION_TOOL } from 'src/data/generationTool';
import { CUSTOM_FORMULA_TYPES } from './customFormulas';
import { CHANNEL } from './channel';

export const CUSTOM_FORMULA_TYPE_GROUPS = {
  [CUSTOM_FORMULA_TYPES.email]: {
    key: CUSTOM_FORMULA_TYPES.email,
    label: 'Email',
    generationTools: [GENERATION_TOOL.emailSubject, GENERATION_TOOL.emailBody],
    channel: CHANNEL.hubspot,
  },
  [CUSTOM_FORMULA_TYPES.googleAd]: {
    key: CUSTOM_FORMULA_TYPES.googleAd,
    label: 'Google Ads',
    channel: CHANNEL.google,
    generationTools: [
      GENERATION_TOOL.googleHeadlineProduct,
      GENERATION_TOOL.googleDescriptionProduct,
    ],
  },
  [CUSTOM_FORMULA_TYPES.facebookAd]: {
    key: CUSTOM_FORMULA_TYPES.facebookAd,
    label: 'Meta Ads',
    channel: CHANNEL.facebook,
    generationTools: [
      GENERATION_TOOL.facebookPrimaryTextProduct,
      GENERATION_TOOL.facebookHeadlineProduct,
    ],
  },
  [CUSTOM_FORMULA_TYPES.linkedinAd]: {
    key: CUSTOM_FORMULA_TYPES.linkedinAd,
    label: 'Linkedin Ads',
    channel: CHANNEL.linkedin,
    generationTools: [
      GENERATION_TOOL.linkedinHeadlineSingleImage,
      GENERATION_TOOL.linkedinIntroSingleImage,
    ],
  },
  [CUSTOM_FORMULA_TYPES.twitterAd]: {
    key: CUSTOM_FORMULA_TYPES.twitterAd,
    label: 'X Ads',
    generationTools: [GENERATION_TOOL.twitterTitleProduct, GENERATION_TOOL.twitterCopyProduct],
  },
  [CUSTOM_FORMULA_TYPES.facebookPost]: {
    key: CUSTOM_FORMULA_TYPES.facebookPost,
    label: 'Facebook Page',
    channel: CHANNEL.facebookPages,
    generationTools: [GENERATION_TOOL.facebookPost],
  },
  [CUSTOM_FORMULA_TYPES.instagram]: {
    key: CUSTOM_FORMULA_TYPES.instagram,
    label: 'Instagram',
    channel: CHANNEL.instagram,
    generationTools: [GENERATION_TOOL.instagramCaption],
  },
  [CUSTOM_FORMULA_TYPES.linkedinPost]: {
    key: CUSTOM_FORMULA_TYPES.linkedinPost,
    label: 'Linkedin Page',
    channel: CHANNEL.linkedinSocial,
    generationTools: [GENERATION_TOOL.linkedinPost],
  },
  [CUSTOM_FORMULA_TYPES.twitterPost]: {
    key: CUSTOM_FORMULA_TYPES.twitterPost,
    label: 'X post',
    generationTools: [GENERATION_TOOL.tweet],
  },
  [CUSTOM_FORMULA_TYPES.landingPage]: {
    key: CUSTOM_FORMULA_TYPES.landingPage,
    label: 'Landing Page',
    generationTools: [
      GENERATION_TOOL.landingHeadline,
      GENERATION_TOOL.landingSubheader,
      GENERATION_TOOL.landingBenefits,
      GENERATION_TOOL.landingFeatures,
    ],
  },
  [CUSTOM_FORMULA_TYPES.youtubeVideo]: {
    key: CUSTOM_FORMULA_TYPES.youtubeVideo,
    label: 'Youtube Video',
    generationTools: [GENERATION_TOOL.youtubeTitle, GENERATION_TOOL.youtubeDescription],
  },
  [CUSTOM_FORMULA_TYPES.outbrainAd]: {
    key: CUSTOM_FORMULA_TYPES.outbrainAd,
    label: 'Outbrain Ad - Headline',
    generationTools: [GENERATION_TOOL.outbrainHeadlineProduct],
  },
  [CUSTOM_FORMULA_TYPES.taboolaAd]: {
    key: CUSTOM_FORMULA_TYPES.taboolaAd,
    label: 'Taboola Ad - Headline',
    generationTools: [GENERATION_TOOL.taboolaHeadlineProduct],
  },
  [CUSTOM_FORMULA_TYPES.pinterestAd]: {
    key: CUSTOM_FORMULA_TYPES.pinterestAd,
    label: 'Pinterest Ads',
    generationTools: [
      GENERATION_TOOL.pinterestDescriptionProduct,
      GENERATION_TOOL.pinterestTitleProduct,
    ],
  },
  [CUSTOM_FORMULA_TYPES.pinterestPin]: {
    key: CUSTOM_FORMULA_TYPES.pinterestPin,
    label: 'Pinterest Pin',
    generationTools: [GENERATION_TOOL.pinterestPostTitle, GENERATION_TOOL.pinterestPostDescription],
  },
  [CUSTOM_FORMULA_TYPES.amazon]: {
    key: CUSTOM_FORMULA_TYPES.amazon,
    label: 'Amazon Product Listing',
    generationTools: [GENERATION_TOOL.amazonProductListing],
  },
  [CUSTOM_FORMULA_TYPES.wolmart]: {
    key: CUSTOM_FORMULA_TYPES.wolmart,
    label: 'Walmart Product Listing',
    generationTools: [GENERATION_TOOL.walmartProductListing],
  },
  [CUSTOM_FORMULA_TYPES.generalListing]: {
    key: CUSTOM_FORMULA_TYPES.generalListing,
    label: 'General Product Listing',
    generationTools: [GENERATION_TOOL.generalProductListing],
  },
  [CUSTOM_FORMULA_TYPES.seo]: {
    key: CUSTOM_FORMULA_TYPES.seo,
    label: 'SEO Meta Description',
    generationTools: [GENERATION_TOOL.landingSEOMetadata],
  },
};
